import { render, staticRenderFns } from "./AttachedFilesCardTabContent.vue?vue&type=template&id=7b9f78e2&scoped=true&"
import script from "./AttachedFilesCardTabContent.vue?vue&type=script&lang=js&"
export * from "./AttachedFilesCardTabContent.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFilesCardTabContent.vue?vue&type=style&index=0&id=7b9f78e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f78e2",
  null
  
)

export default component.exports